export default __webpack_public_path__ + "static/media/loading.86b6ffe9.gif";